/**
 * @Description: 海报管理
 * @Author Jiang
 * @Date 2020/8/14 18:02
 */
import React, {Component} from "react";
import {Button, Card, Col, DatePicker, Input, message, Modal, Row, Select, TimePicker, Upload} from "antd";
import {
  API_IMG_PLATE_UPLOAD,
} from "../../../../constants";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import moment from 'moment';
import classnames from "classnames";
import './index.less'
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import MyButton from "../../../../components/Button";
import {
  getProductQueryProducts,
  getRemodelPlateSave,
  getRemodelPostSearchDetail,
  getRemodelPostSave
} from "../../../../constants/api";
import {removeToken} from "../../../../utils/cookie";

import {COMMON_ROUTER} from "../../../../constants";

const {RangePicker} = DatePicker;
const {Option} = Select
const format = 'HH:mm';
export default class Poster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],//图片列表
      decorationShopPostId: '',  //海报id
      effectiveDate: '',
      effectiveTime: '',
      elemePostId: '',
      expiryDate: '',
      expiryTime: '',
      imageHash: '',
      imageUrl: '',
      postName: '',  //海报名称
      products: [],  //关联商品
      addVisible: false,
      showImg: true,
      selectId: []  //已选商品
    }
  }


  componentWillMount() {
    if (this.props.location.state) {
      this.setState({
        templateId: this.props.location.state.templateId,
        shopId: this.props.location.state.shopId,
        decorationShopPostId: this.props.location.state.decorationShopPostId,
      })
    }
  }

  componentDidMount() {
    this.getTemplateId()
  }

  getTemplateId = () => {
    let storage = window.localStorage;
    let templateId = storage.getItem('templateId');
    let platformType = storage.getItem('platformType')
    if (templateId && platformType) {
      this.setState({
        templateId: templateId,
        platformType: platformType
      }, () => {
        this.getPoster(templateId, platformType)
        this.getGoodsCategory(templateId, platformType)
      })
    } else {
      message.error('请先选择总店', 1)
    }
  }

  getPoster(templateId, platformType) {
    getRemodelPostSearchDetail({
      shopId: 0,
      templateId: templateId,
      platformType: platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let poster = data.data;
          let products = [];
          if (data.data.products) {
            products = data.data.products;
          }

          let selectId = [];
          products.map((item, index) => {
            selectId.push(item.productRelationId)
          })
          console.log(products)
          console.log(selectId)
          this.setState({
            decorationShopPostId: poster.decorationShopPostId,
            effectiveDate: poster.effectiveDate,
            effectiveTime: poster.effectiveTime,
            elemePostId: poster.elemePostId,
            expiryDate: poster.expiryDate,
            expiryTime: poster.expiryTime,
            imageHash: poster.imageHash,
            imageUrl: poster.imageUrl,
            postName: poster.postName,
            products: products,
            selectId: selectId
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_POSTER_SEARCH, {
    //   // id: this.state.decorationShopPostId,
    //   shopId: 0,
    //   templateId: templateId,
    //   platformType: platformType
    // }).then(res => {
    //   if (res.status === 200) {
    //     console.log(res)
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let poster = data.data;
    //       let products = [];
    //       if (data.data.products) {
    //         products = data.data.products;
    //       }
    //
    //       let selectId = [];
    //       products.map((item, index) => {
    //         selectId.push(item.productRelationId)
    //       })
    //       console.log(products)
    //       console.log(selectId)
    //       this.setState({
    //         decorationShopPostId: poster.decorationShopPostId,
    //         effectiveDate: poster.effectiveDate,
    //         effectiveTime: poster.effectiveTime,
    //         elemePostId: poster.elemePostId,
    //         expiryDate: poster.expiryDate,
    //         expiryTime: poster.expiryTime,
    //         imageHash: poster.imageHash,
    //         imageUrl: poster.imageUrl,
    //         postName: poster.postName,
    //         products: products,
    //         selectId: selectId
    //       })
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  getGoodsCategory(templateId, platformType) {
    getProductQueryProducts({
      shopId: this.state.shopId,
      templateId: templateId,
      platformType: platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            goodscategory: data.data
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_CATEGORY, {
    //   // shopIds: this.state.shopId,
    //   // id: this.state.shopId,
    //   shopId: this.state.shopId,
    //   templateId: templateId,
    //   platformType: platformType
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       this.setState({
    //         goodscategory: data.data
    //       })
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  //base64图片文件
  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  //图片预览取消函数
  handleCancel = () => this.setState({previewVisible: false});

  //图片预览弹窗函数
  handlePreview = async file => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };
  beforeUpload = (file) => {
    // console.log(file)
    // 控制上传图片格式
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      message.error('您只能上传JPG/PNG 文件!');
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error('图片大小必须小于5MB!');
      return false;
    }
    return isJpgOrPng && isLt2M;
  }

  //上传文件改变时的状态，详情可以参考antd的Upload组件API参数
  onImgChange = ({fileList, file, event}) => {
    this.setState({
      fileList: fileList,
      showImg: false,
    })
  };

  formatDateCommon(v, format) {
    if (!v) {
      return "";
    }
    var dateV = new Date(v);
    var year = dateV.getFullYear();
    var month = dateV.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var date = dateV.getDate();
    date = date < 10 ? ("0" + date) : date;
    var hour = dateV.getHours();
    hour = hour < 10 ? ("0" + hour) : hour;
    var minute = dateV.getMinutes();
    minute = minute < 10 ? ("0" + minute) : minute;
    var second = dateV.getSeconds();
    second = second < 10 ? ("0" + second) : second;
    var str1 = year + "-" + month + "-" + date
    var str2 = hour + ":" + minute + ":" + second;
    var str
    if ("yyyy-MM-dd" == format) {
      str = str1;
    } else {
      str = str1 + " " + str2
    }
    return str;
  };

  handleChange = (type, e, timeString) => {
    console.log(e)
    switch (type) {
      case 'status':
        this.setState({
          windowStatus: e.target.value
        })
        break;
      case 'name':
        this.setState({
          postName: e.target.value
        })
        break;
      case 'startTime':
        let effectiveDate = e[0];
        let expiryDate = e[1];
        effectiveDate = moment(effectiveDate).valueOf()
        effectiveDate = this.formatDateCommon(effectiveDate, "yyyy-MM-dd")
        expiryDate = moment(expiryDate).valueOf()
        expiryDate = this.formatDateCommon(expiryDate, "yyyy-MM-dd")
        this.setState({
          effectiveDate: effectiveDate,
          expiryDate: expiryDate,
        })
        break;
      case 'effectStart':
        console.log(timeString)
        this.setState({
          effectiveTime: timeString
        })
        break;
      case 'effectEnd':
        console.log(timeString)
        this.setState({
          expiryTime: timeString
        })
        break;
      case 'product':
        this.setState({
          selectId: e
        })
        break;
      default:


    }
  }
  setModal = () => {
    this.setState({
      addVisible: true
    })
  }

  /**
   * @Description: 发布招牌
   * @Author Jiang
   * @Date 2020/8/14 16:34
   */
  addPoster() {
    //商品图片
    let fileList = this.state.fileList
    let file = fileList[0];
    let res = file.response;
    if (res.code === 0) {
      let img = res.data
      var imageHash = img.imageHash
      var imageUrl = img.imageUrl
    }

    getRemodelPlateSave({
      imageHash: imageHash,
      imageUrl: imageUrl,
      shopId: this.state.shopId,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success('更换成功', 1, () => this.getShopSign())
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
    // axios.post(API_SHOP_POSTER, {
    //   imageHash: imageHash,
    //   imageUrl: imageUrl,
    //   shopId: this.state.shopId,
    //   templateId: this.state.templateId
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       message.success('更换成功', 1, () => this.getShopSign())
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  handleCancel = () => {
    if (!(this.state.selectId.length >= 1 && this.state.selectId.length <= 20)) {
      message.error('商品数必须在1-20个之间', 1)
      return
    }
    let selectId = [];
    this.state.products.map((item, index) => {
      selectId.push(item.productRelationId)
    })
    this.setState({
      addVisible: false,
      selectId: selectId
    })
  }
  handleOk = () => {
    if (!(this.state.selectId.length >= 1 && this.state.selectId.length <= 20)) {
      message.error('商品数必须在1-20个之间', 1)
      return
    }
    let goodscategory = this.state.goodscategory
    let selectId = this.state.selectId
    let new_products = [];
    console.log(selectId)
    console.log(goodscategory)
    goodscategory.map((item, index) => {
      if (selectId.includes(item.productRelationId)) {
        console.log('------------')
        new_products.push(item)
      }
    })
    this.setState({
      products: new_products,
      addVisible: false
    })
  }

  submit = () => {
    console.log(this.state.templateId)


    let fileList = this.state.fileList
    let imageHash = ''
    let imageUrl = ''
    if (fileList.length > 0) {
      let file = fileList[0];
      let res = file.response;
      if (res.code === 0) {
        let img = res.data
        imageHash = img.imageHash
        imageUrl = img.imageUrl
      }
    } else {
      imageHash = this.state.imageHash
      imageUrl = this.state.imageUrl
    }

    getRemodelPostSave({
      decorationShopPostId: this.state.decorationShopPostId,
      effectiveDate: this.state.effectiveDate,
      effectiveTime: this.state.effectiveTime,
      elemePostId: this.state.elemePostId,
      expiryDate: this.state.expiryDate,
      expiryTime: this.state.expiryTime,
      imageHash: imageHash,
      imageUrl: imageUrl,
      postName: this.state.postName,
      productIds: this.state.selectId,
      shopId: this.state.shopId,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          console.log(this.props.history)
          this.props.history.push(COMMON_ROUTER + '/shopRenovation')
          message.success('发布成功', 1)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_POSTER_SAVE, {
    //   decorationShopPostId: this.state.decorationShopPostId,
    //   effectiveDate: this.state.effectiveDate,
    //   effectiveTime: this.state.effectiveTime,
    //   elemePostId: this.state.elemePostId,
    //   expiryDate: this.state.expiryDate,
    //   expiryTime: this.state.expiryTime,
    //   imageHash: imageHash,
    //   imageUrl: imageUrl,
    //   postName: this.state.postName,
    //   productIds: this.state.selectId,
    //   shopId: this.state.shopId,
    //   templateId: this.state.templateId
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       console.log(this.props.history)
    //       this.props.history.push(COMMON_ROUTER + '/shopRenovation')
    //       message.success('发布成功', 1)
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  cancel = () => {
    this.props.history.push(COMMON_ROUTER + '/shopRenovation')
  }

  delete = (index) => {
    let products = this.state.products;
    console.log(products)
    products.splice(index, 1)
    let selectId = [];
    products.map((item, index) => {
      selectId.push(item.productRelationId)
    })
    this.setState({
      products: products,
      selectId: selectId
    })
  }

  render() {
    //根据官方属性定制化裁剪框大小固定的裁剪组件属性
    const props = {
      width: 500,  //裁剪宽度
      height: 300, //裁剪高度
      resize: false, //裁剪是否可以调整大小
      resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
      modalTitle: "上传图片", //弹窗标题
      modalWidth: 600, //弹窗宽度
    };

    let {fileList, postName, products, effectiveDate, effectiveTime, expiryDate, expiryTime} = this.state
    console.log(effectiveTime, expiryTime)
    console.log('+++++++++++')
    console.log(products)
    return (
      <Card style={{width: '100%',overflowY:"scroll",height: '100vh',padding:'0 0 60px'}}  title={'编辑店内海报'}>
        <Row justify='center'>
          <Col className={classnames('sign')}>
            <div className='sign-title'>
              店内海报
            </div>
            <div>
              {this.state.showImg ?
                <img src={this.state.imageUrl} className={classnames('shop-img', 'row-bottom')}/> : null}
              {/*<ImgCrop {...props} className='shop-img'>*/}
              <Upload
                name="file"
                action={API_IMG_PLATE_UPLOAD}
                accept="image/*"
                listType="picture"
                fileList={fileList}
                beforeUpload={this.beforeUpload}
                onPreview={this.handlePreview}
                onChange={this.onImgChange}
              >
                {fileList.length >= 1 ? null : (<div className='img-container'>
                  <div>
                    <PlusOutlined style={{fontSize: "20px"}}/>
                    点击更换
                  </div>
                </div>)}
                {/* {通过三木运算符判断文件列表fileList的长度来决定上传图片的数量，达到控制图片数量的功能} */}
              </Upload>
              {/*  </ImgCrop>*/}
              {/*橱窗标题*/}
              <Row justify={'center'} className='row-bottom'>
                <Col>
                  <div className='title'>
                    <div>
                      名称
                    </div>
                    <div>
                      <Input defaultValue={postName} value={postName} onChange={this.handleChange.bind(this, 'name')}
                             style={{width: '400px', height: '40px', borderRadius: '12px', marginTop: '10px'}}/>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row justify={'center'} className='row-bottom'>
                <Col>
                  <div className='title'>
                    <div>
                      起止日期
                    </div>
                    <div>
                      <div>
                        <RangePicker style={{width: '400px'}}
                                     value={[moment(effectiveDate, 'YY-MM-DD'), moment(expiryDate, 'YY-MM-DD')]}
                                     onChange={this.handleChange.bind(this, 'startTime')}/>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row justify={'center'} className='row-bottom'>
                <Col>
                  <div className='title'>
                    <div>
                      生效时段
                    </div>
                    <div>
                      <div className={'effective'}>
                        <TimePicker
                          allowClear={false}
                          style={{width: "180px"}}
                          value={moment(effectiveTime, format)}
                          onChange={this.handleChange.bind(this, 'effectStart')}
                          format={format}/>
                        <div style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: 'center',
                          fontSize: "12px",
                          width: "40px",
                          marginLeft: "10px",
                          marginRight: "10px"
                        }}>至
                        </div>
                        <TimePicker
                          allowClear={false}
                          style={{width: "180px"}}
                          value={moment(expiryTime, format)}
                          onChange={this.handleChange.bind(this, 'effectEnd')}
                          format={format}/>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row justify={'center'} className='row-bottom'>
                {/*商品*/}
                <Col>
                  <div className={classnames('title', 'window')}>
                    {products && products.map((product, index) => {
                      return <div key={index} className={'row-bottom'}>
                        <div className='shop-row'>
                          <div>
                            {product.productName}
                          </div>
                          <Button style={{borderWidth: 0}} onClick={this.delete.bind(this, index)}>
                            <div>
                              <DeleteOutlined/>移除
                            </div>
                          </Button>

                        </div>
                      </div>
                    })}
                    {
                      products && products.length <= 20 ? <div className={classnames('add-goods', 'row-bottom')}>
                        <Button onClick={this.setModal.bind(this)} type={'primary'}>添加商品</Button>
                      </div> : null
                    }
                  </div>
                </Col>
              </Row>
              <Row justify='center'>
                <Col>
                  <div className='title-btn'>
                    <MyButton title={'取消'} onClick={this.cancel.bind(this)}/>
                    <MyButton title={'确认发布'} onClick={this.submit.bind(this)} type={'primary'}/>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Modal
          title="关联商品"
          visible={this.state.addVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确认"
          cancelText="取消"
        >
          <Select style={{width: "400px"}} value={this.state.selectId}
                  onChange={this.handleChange.bind(this, 'product')} mode="multiple">
            {this.state.goodscategory && this.state.goodscategory.map((item, index) => {
              return <Option key={item.productRelationId} value={item.productRelationId}>{item.productName}</Option>
            })}
          </Select>
        </Modal>
      </Card>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/shopmanage/shoprenovation/poster/index.js